import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'row', 'empty']

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()
    let matches = 0

    this.rowTargets.forEach(row => {
      const match = row.dataset.name.toLowerCase().includes(query)

      row.hidden = !match
      if (match) matches += 1
    })

    this.emptyTarget.hidden = matches > 0
  }
}
